<!-- main-wrapper.component.html -->

<div class="main-wrapper app-container" [ngClass]="{
    'login-body': page === 'admin-login' || page === 'admin-register' || page === 'admin-lock-screen' || page === 'admin-forgot-password' || page === 'pharmacy-login' || page === 'pharmacy-register' || page === 'pharmacy-lock-screen' || page === 'pharmacy-forgot-password',
    'expand-menu': expandMenu && miniSidebar,
    'mini-sidebar': miniSidebar,
    'slide-nav': mobileSidebar,
    'home-ten': base === 'home5',
    'home-twelve': base === 'home7' || page === 'home8',
    'home-fourteen': base === 'home9',
    'home-thirteen': base === 'home8',
    'home-sixteen': base === 'home11',
    'menu-opened': showMiniSidebar,
    'profile-setting-class': page === 'profile-settings' || page === 'doctor-search-grid' || page === 'doctor-profile-settings' || last === 'search2',
    'login-content': page === 'admin-login' || page === 'admin-register' || page === 'lock-screen' || page === 'admin-forgot-password' || page === 'pharmacy-login' || page === 'pharmacy-forgot-password' || page === 'pharmacy-register',
    'home-pg-twelve': base === 'home12',
    'pharmacy-body': page === 'pharmacy-index'
  }">
  <router-outlet></router-outlet>

  @if (popupService.showPopup) {
    <app-ambulance></app-ambulance>
  }

  <!-- <app-incoming-call></app-incoming-call> -->
</div>

<!-- <app-pip-overlay></app-pip-overlay> -->
<app-modal></app-modal>
<!-- <dependent-modal></dependent-modal> -->
<!-- <app-missed-call-popup></app-missed-call-popup> -->
